import { Inspection } from './inspection.model';
import { InspectionPoint } from './inspectionPoint.model';
import { ISearch } from './ISearch.model';
import { IHost } from './IHost.model';
import { IInspectionVisitor } from './IInspectionVisitor.model';
import { InspectionSession } from './multi-edit.model';

export class InspectionPlugin implements ISearch, IHost {
  public config: any = {};
  public inspection: Inspection;
  public pointId: string;
  public parentPluginId: string;
  public point: InspectionPoint;
  public code: string;
  public inspectionId: string;
  public required: boolean;
  public etag: Date;
  public references: any[];
  public description: string;
  public name: string;
  public propertyList: any[];
  public postServerUrl: string;
  public status: number;
  public plugins: InspectionPlugin[] = [];
  public sessions: InspectionSession[];
  public slotPath: string;
  public synchronizationEnabled?: boolean;

  constructor(public id: string, public order: number, public pluginType: string) {
    this.plugins = [];
    this.sessions = [];
  }

  get sessionIcons(): InspectionSession[] {
    return this.inspection.sessions?.map((s) => {
      const entitySession = new InspectionSession();
      Object.assign(entitySession, s);
      entitySession.highlight = this.sessions?.includes(s);
      return entitySession;
    });
  }

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    return this.pluginType == null || this.pluginType.toLowerCase().indexOf(queryToLower) !== -1;
  }

  public accept(visitor: IInspectionVisitor): void {
    visitor.visit(this);
  }
}
